/** Firmenname autocomplete tunables (one register fetch per stem, ranked locally). */

/** Keystroke debounce before a new stem is fetched. */
export const FIRM_NAME_DEBOUNCE_MS = 200;
/** Browser-side cache per stem (the api caches the same 5 minutes). */
export const FIRM_NAME_CACHE_MS = 300_000;
/** Rows rendered in the dropdown; the rest is only counted in the hint. */
export const FIRM_NAME_VISIBLE_ROWS = 6;
